import React from 'react';
import { useInView } from 'react-intersection-observer';
import './styles.css';

const AnimatedSection = ({ children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Animasikan hanya sekali
    threshold: 0.1, // Picu animasi saat 10% elemen terlihat
    rootMargin: '0px 0px -50px 0px', // Picu sedikit lebih awal
  });

  return (
    <div
      ref={ref}
      className={`section-animate ${inView ? 'is-visible' : ''}`}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;